module.exports = __webpack_public_path__ + "dfddfd7baf3846563c22b069ed0905ff.svg";